import FormBuilder from './FormBuilder.vue';

export default FormBuilder;
